import ConstructiveFeedbackContent from "./ConstructiveFeedbackContent";

export default function ConstructiveFeedbackContainer({handleClose}) {

    return(
        <ConstructiveFeedbackContent
            handleClose={handleClose}
        />
    )
}